import PartnerAccountInfoPanel from './PartnerAccountInfoPanel';

export default PartnerAccountInfoPanel;
